import {extractLastFieldName, flattenObjectRecursive, getFieldNameBuilder} from "./../util";
import {ContinuousConditions} from "./partials/conditions/ContinuousConditions";
import {ScheduledConditions} from "./partials/conditions/ScheduledConditions";

const SlottedTimeValue = ({ name, title, slots, slotValueFieldDefinitions, scheduledTypesArgs, onChange}) => {

  slots = slots || []

  const typeFieldName = !name.includes('[')
    ? `${name}_type`
    : extractLastFieldName(name) + '_type';
  const prepareSlots = (slots) => {

    // This entire block tries to account for edge cases
    let now = new Date();
    for(const slot of slots) {
      slot.start_date = slot.start_date || {
        year: now.getFullYear(),
        month: now.getMonth() + 1,
        day: now.getDate()
      }
      slot.end_date = slot.end_date || {
        year: now.getFullYear() + 1,
        month: now.getMonth() + 1,
        day: now.getDate()
      }
    }
    slots = slots.map(
      (slot) => slot.type === 'recurring' ? slot : flattenObjectRecursive(slot, '', [], ['from', 'to'])
    );

    for (let i = 0; i < slots.length; i++) {
      let slot = slots[i],
        type = slot.type || slot[typeFieldName]; // When using this inside a repeater, it gets redrawn, and we have to do some guessing
      slot[typeFieldName] = type;

      // These are galactic levels of type non-coalescing garbage
      slot.from_month && (slot.from_month = slot.from_month.toString())
      slot.to_month && (slot.to_month = slot.to_month.toString())
      slot.period_from?.month && (slot.period_from.month = slot.period_from.month.toString())
      slot.period_to?.month && (slot.period_to.month = slot.period_to.month.toString())
      slot.start_date?.month && (slot.start_date.month = slot.start_date.month.toString())
      slot.end_date?.month && (slot.end_date.month = slot.end_date.month.toString())
      slot.priority = i + 1;


      let innerSlot = {...slot},
        key = type + 'Criteria';

      delete innerSlot[key];
      slot[key] = innerSlot;
    }

    return slots;
  }

  return tangibleFields.render({
    type: 'repeater',
    name: name,
    layout: 'block',
    value: prepareSlots(slots) ?? [{}],
    sectionTitle: title,
    fields: [
      { type: 'number', name: 'priority', label: 'Priority', minValue: 0 },
      ...slotValueFieldDefinitions,
      { type: 'radio', name: typeFieldName, label: 'Event Type', choices: scheduledTypesArgs.eventTypes },
      ContinuousConditions(typeFieldName),
      ScheduledConditions(typeFieldName),
      {
        type: 'recurringIntervalConditions',
        name: 'recurringCriteria',
        condition: {
          action: 'show', condition: {[typeFieldName]: {'_eq': 'recurring'}}
        },
      },
    ],
    onChange
  })

}

export { SlottedTimeValue }
